import styled from '@emotion/styled';
import { colors, fontSize } from '../../../global/variables';

const {
  secondaryTextColor,
  primaryTextColor,
  primaryBorderColor,
  secondaryBorderColor,
  placeholderTextColor,
  aqua,
} = colors;
const { small, smaller, normal } = fontSize;

export const StyledEditor = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden',
});

export const StyledEditorBody = styled.div({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  padding: '1rem 1.2rem',
});

export const StyledGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '0.75rem',
  marginBottom: '0.9rem',
});

export const StyledGridThree = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '0.75rem',
  marginBottom: '0.9rem',
});

export const StyledField = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

export const StyledLabel = styled.label({
  fontSize: smaller,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  fontWeight: 700,
  color: secondaryTextColor,
  marginBottom: '0.3rem',
});

export const StyledRequiredMark = styled.span({
  color: '#E5484D',
  marginLeft: '0.2rem',
});

export const StyledInput = styled.input({
  width: '100%',
  boxSizing: 'border-box',
  minWidth: 0,
  fontSize: normal,
  color: primaryTextColor,
  border: `1px solid ${aqua}`,
  backgroundColor: 'rgba(34,205,200,.05)',
  borderRadius: '0.12rem',
  padding: '0.55rem 0.65rem',
  fontFamily: 'FiraGO',
  '&::placeholder': {
    fontStyle: 'italic',
    fontWeight: 300,
    color: placeholderTextColor,
  },
  '&::-webkit-input-placeholder': {
    fontStyle: 'italic',
    fontWeight: 300,
    color: placeholderTextColor,
  },
  '&::-moz-placeholder': {
    fontStyle: 'italic',
    fontWeight: 300,
    color: placeholderTextColor,
  },
  '&:-ms-input-placeholder': {
    fontStyle: 'italic',
    fontWeight: 300,
    color: placeholderTextColor,
  },
});

export const StyledSelect = styled.select({
  width: '100%',
  boxSizing: 'border-box',
  minWidth: 0,
  fontSize: normal,
  color: primaryTextColor,
  border: `1px solid ${aqua}`,
  backgroundColor: 'rgba(34,205,200,.05)',
  borderRadius: '0.12rem',
  padding: '0.55rem 0.65rem',
  fontFamily: 'FiraGO',
});

export const StyledFooter = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.45rem',
  justifyContent: 'flex-end',
  flexShrink: 0,
  padding: '0.7rem 1.2rem',
  borderTop: `1px solid ${secondaryBorderColor}`,
});

const StyledButton = styled.button({
  fontFamily: 'FiraGO',
  fontSize: small,
  fontWeight: 500,
  borderRadius: '0.12rem',
  padding: '0.55rem 1.1rem',
  cursor: 'pointer',
});

export const StyledCancelButton = styled(StyledButton)({
  background: 'transparent',
  color: primaryTextColor,
  border: `1px solid ${primaryBorderColor}`,
});

export const StyledSaveButton = styled(StyledButton)(({ disabled }) => ({
  background: aqua,
  color: '#fff',
  border: 'none',
  opacity: disabled ? 0.5 : 1,
  cursor: disabled ? 'not-allowed' : 'pointer',
}));
